import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IExhibitorMeetingByDatePayloadState } from '@app-store/slices/meetingStatistics/exhibitorMeetingByDate'

interface TaskAction extends Action {
    payload: IExhibitorMeetingByDatePayloadState
}

const { onRequest, onSuccess, onFailure } = rootActions.meetingStatistics.exhibitorMeetingByDate

function* exhibitorMeetingByDateSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.get(`/meeting/stats/exhibitor/meeting-by-date`)
        if (response.success) {
            yield put(onSuccess(response.result.data))
            yield payload?.sagaCB && payload.sagaCB?.onSuccess()
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
        yield payload?.sagaCB && payload.sagaCB?.onError()
    }
}

function* exhibitorMeetingByDateSaga(): any {
    yield takeLatest<TaskAction>(onRequest, exhibitorMeetingByDateSagaTask)
}

export default exhibitorMeetingByDateSaga
